module.exports = __webpack_public_path__ + "img/regulation-5.3cc55262.svg";